module.exports = __webpack_public_path__ + "static/media/1.648b924f.jpg";